// *********************** 4T系列 *************************
  // 切换显示不同摄像头内容的函数
  function showContent(index) {
    if(index || index==0){
      // 隐藏所有摄像头内容
      const contents = document.querySelectorAll('.content-liteenterprise');

      if(contents.length>0){
        document.querySelectorAll('.content-liteenterprise').forEach(content => {
          content.classList.remove('active-liteenterprise');
        });
        
        // 显示选中的摄像头内容
        if(typeof index == 'number'){
            contents[index].classList.add('active-liteenterprise');
        }
      }
      
      
      // 更新按钮active状态
      document.querySelectorAll('.nav-item-liteenterprise').forEach((button, idx) => {
        button.classList.remove('active-liteenterprise');
        if (idx == index) {
          button.classList.add('active-liteenterprise');
        }
      });
    }
  }

  // 初始化事件监听器
  document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.nav-item-liteenterprise');
    if(buttons){
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          showContent(index);
        });
      });
    }
    // 设置默认显示第一个摄像头（Thermal Camera）
    showContent(0);

    // specificatiion tab切换
    const specificationTabs = document.querySelectorAll('.specification-tab-btn');
    const specificationPanels = document.querySelectorAll('.specification-panel');
    specificationTabs.forEach(tab => {
      tab.addEventListener('click', function () {
        specificationTabs.forEach(btn => {
          btn.classList.remove('active');
        });
        specificationPanels.forEach(panel => {
          panel.classList.remove('active');
        });
        this.classList.add('active');
        const targetPanel = document.getElementById(this.dataset.tab);
        if(targetPanel){
          targetPanel.classList.add('active');
        }
      });
    });


  });